"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
0 && (module.exports = {
    getManifest: null,
    setManifest: null
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getManifest: function() {
        return getManifest;
    },
    setManifest: function() {
        return setManifest;
    }
});
const _global = require("./global");
const setManifest = (callback)=>{
    try {
        const manifest = callback();
        (0, _global.setGlobal)('manifest', manifest);
    } catch (e) {
        (0, _global.setGlobal)('manifest', {});
    }
};
const getManifest = ()=>{
    return _global.globals.get('manifest');
};
